import { render, staticRenderFns } from "./ResShareStorage.vue?vue&type=template&id=65eef414"
import script from "./ResShareStorage.vue?vue&type=script&lang=js"
export * from "./ResShareStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports